import { AccountType } from "./UserTypes";

export enum ContactStatus {
  Verified = "Verified",
  Pending = "Pending",
  Expired = "Expired",
}

export interface BaseContactLink {
  email: string;
  first_name: string;
  last_name: string;
}

export interface ContactLink extends BaseContactLink {
  id: string;
  from_user_name: string;
  from_user_account: string;
  user_with_email_exists: boolean;
  is_expired: boolean;
}

export interface BaseContact {
  account_type: AccountType;
  contact_name: string;
  status: ContactStatus;
  email: string;
}

export interface Contact extends BaseContact {
  id: string;
}
